interface Params<T> {
    [Key: string]: T
}

function cast(value: string | undefined): string {
    return value || ''
}

function parameters({brand, account}: AppEntity): Params<string> {
    return {
        brand: brand.encodedName,
        email: cast(account?.email),
        pass: cast(account?.password),
        team_id: cast(account?.teamId),
        team_name: cast(account?.teamName),
    }
}

function buildQuery(object: Params<string> = {}): string {
    return Object.entries(object)
        .map((param) => `${encodeURIComponent(param[0])}=${encodeURIComponent(param[1])}`)
        .join('&')
}

export function iOSLoginIsRequired(app: AppEntity): boolean {
    return app.account?.type === 'individual' && app.iOS?.request === true
}

export function iOSLoginUrl(app: AppEntity): string {
    const params = parameters(app)
    return `http://fastlane-ios-login.dd.com?${buildQuery(params)}`
}
